export default "__VITE_ASSET__08bac426__"